import { JsonObject, JsonProperty } from 'json2typescript';
import { DictDataParamType } from './dict-data-param-type.enum';

@JsonObject
export class DictDataParam {

  @JsonProperty('searchId', Object)
  public searchId: number = undefined;

  @JsonProperty('searchType', String)
  public searchType: DictDataParamType = undefined;

  constructor(searchId?: number, searchType?: DictDataParamType) {
    this.searchId = searchId;
    this.searchType = searchType;
  }

  isTenant() {
    return this.searchType === DictDataParamType.TENANT;
  }

  isDept() {
    return this.searchType === DictDataParamType.DEPT;
  }

  isGroup() {
    return this.searchType === DictDataParamType.GROUP;
  }
}
